import { View } from '@react-pdf/renderer';
import React, { Fragment } from 'react';

import Projection from './Projection';

const ProjectionsPage = ({ projections }) =>
  projections.map((projection) => {
    const hasTechnologistComments = projection.points.some(
      (point) => point.typeCode === 'TECHNOLOGIST',
    );

    return (
      <Fragment key={projection.id}>
        <View break>
          <Projection projection={projection} type="DESIGNER" />
        </View>
        {hasTechnologistComments && (
          <View break>
            <Projection projection={projection} type="TECHNOLOGIST" />
          </View>
        )}
      </Fragment>
    );
  });

export default ProjectionsPage;
